import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader
} from "@ey-xd/motif-react";
import React from "react";
import "@/components/Modal/ConfirmationModal/confirmationModal.scss";
import Button from "@/components/Form/Button/Button";
import { useTranslation } from "react-i18next";
import {
  CANCEL_BUTTON_VARIANT,
  YES_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";

type Props = {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  cancelBtnHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  confirmBtnHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  confirmationMessage: string;
  loadingFlag?: boolean;
  unitToDelete?: any;
};

export default function ConfirmationModalUnit({
  isVisible,
  setIsVisible,
  cancelBtnHandler,
  confirmBtnHandler,
  confirmationMessage,
  loadingFlag,
  unitToDelete
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <MotifModal
        onClose={() => setIsVisible(false)}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>
          <MotifModalBody style={{ paddingTop: "0px" }}>
            {useTrans(
              t,
              t(confirmationMessage, { unitName: unitToDelete }),
              "unitName"
            )}
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={t("global.globalActions.yes")}
              loading={loadingFlag}
              variant={YES_BUTTON_VARIANT}
              className="delBtn mar-t-0"
              onClickHandler={confirmBtnHandler}
            />
            <Button
              label={t("global.globalActions.no")}
              variant={CANCEL_BUTTON_VARIANT}
              className="cancelBtnModal  mar-t-0"
              onClickHandler={cancelBtnHandler}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
